const base = {
  collapseAt: '1000px'
};

const press = {
  collapseAt: '1023px'
};

const collapseAt = {
  ...base,
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    press,
    spark: base
  }
};

export default collapseAt;
